import { MegaLayout, FormMegaLayout } from '@formily/antd';
export { MegaLayout, FormMegaLayout, };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/form-mega-layout/index.js
// module id = 6300
// module chunks = 0